import { useMemo } from "preact/hooks";
import PropTypes from "prop-types";
import Button from "@/components/buttons/button.jsx";
import Picker from "@/components/input/picker.input.jsx";
import YesNoButtonInput from "@/components/input/yes-no-button.input.jsx";
import { isYes } from "@/util/common.js";

TwitchChatbotSettings.propTypes = {
  config: PropTypes.shape({
    donationOnOff: PropTypes.string,
    timerOptions: PropTypes.string,
    milestoneMessages: PropTypes.string,
    donationMessageType: PropTypes.string,
  }).isRequired,
  chatbotConnected: PropTypes.bool.isRequired,
  setConfigState: PropTypes.func.isRequired,
  connectChatbot: PropTypes.func.isRequired,
  disableConnectionButton: PropTypes.bool.isRequired,
  isCampaignRetired: PropTypes.bool.isRequired,
  hasLoadedCampaign: PropTypes.bool.isRequired,
  tiltifyCampaignID: PropTypes.string.isRequired,
};
export default function TwitchChatbotSettings({
  config,
  chatbotConnected,
  setConfigState,
  connectChatbot,
  disableConnectionButton,
  isCampaignRetired,
  hasLoadedCampaign,
  tiltifyCampaignID,
}) {
  const donationLinkOptions = [
    {
      value: "default",
      name: "Default",
    },
    {
      value: "incentives",
      name: "Incentives",
    },
    {
      value: "details",
      name: "Details",
    },
  ];

  const timerOptions = [
    {
      value: "5",
      name: "Five minutes",
    },
    {
      value: "10",
      name: "Ten minutes",
    },
    {
      value: "15",
      name: "Fifteen minutes",
    },
  ];

  const donationMessagePreview = useMemo(() => {
    if (config.donationMessageType === "default") {
      return `https://donate.tiltify.com/${tiltifyCampaignID}`;
    }

    return `https://donate.tiltify.com/${tiltifyCampaignID}/${config.donationMessageType === "details" ? "details" : "incentives"}?origin=donate`;
  });

  return (
    <div className="min-h-[250px]">
      <div className="flex flex-col md:flex-row">
        <YesNoButtonInput
          disabled={chatbotConnected}
          mode="checkbox"
          onChange={setConfigState}
          currentValue={config.donationOnOff}
          name="donationOnOff"
          className="md:mr-4 mb-2 md:mb-0 flex-1"
          label="Post donation link at specific intervals"
        />
        <YesNoButtonInput
          disabled={chatbotConnected}
          mode="checkbox"
          onChange={setConfigState}
          currentValue={config.milestoneMessages}
          name="milestoneMessages"
          className="flex-1"
          label="Post milestone messages"
        />
      </div>
      <div className="mt-1">
        <Picker
          items={timerOptions}
          fieldName="timerOptions"
          onChange={setConfigState}
          currentValue={config.timerOptions}
          labelText="Message Timer"
          disabled={!isYes(config.donationOnOff) || chatbotConnected}
        />
        <article className="prose text-sm mt-2 ml-1">
          Set the desired minutes before message repeats
        </article>
      </div>

      <div className="mt-1">
        <Picker
          items={donationLinkOptions}
          fieldName="donationMessageType"
          onChange={setConfigState}
          currentValue={config.donationMessageType}
          labelText="Donation Message Type"
          disabled={chatbotConnected}
        />
        <article className="prose text-sm mt-2 ml-1">
          Your donation link will be: '{donationMessagePreview}'
        </article>
      </div>

      <Button
        onClick={connectChatbot}
        mode="button"
        style="primary"
        className="mt-5"
        analyticsTrackingName="connect-twitch-chatbot"
        disabled={disableConnectionButton || isCampaignRetired}
      >
        Connect Chatbot
      </Button>

      <div className="mt-1">
        <span
          className={`text-sm ${isCampaignRetired && hasLoadedCampaign ? "opacity-100" : "opacity-50"}`}
        >
          You cannot use a retired campaign with a chatbot
        </span>
      </div>
    </div>
  );
}
